import { FloatingPortal } from '@floating-ui/react';
import { TooltipProps } from '../Tooltip.typed';
import { BaseTooltip } from '../BaseTooltip/BaseTooltip';
import * as Styled from '../Tooltip.styled';
import { useTheme } from 'styled-components';
import { forwardRef, useId } from 'react';
import Icon from '../../Icon/Icon';
import { TooltipSizeValue } from 'styled-system';

export type ToggletipProps = TooltipProps & {
  handleClose: () => void;
  size?: TooltipSizeValue;
};
export const ToggletipComponent = forwardRef<HTMLDivElement, ToggletipProps>(
  (
    {
      arrowRef,
      children,
      handleClose,
      context,
      role = 'dialog',
      size = 'm',
      ...rest
    },
    ref,
  ) => {
    const theme = useTheme();
    const id = useId();
    return (
      <FloatingPortal>
        {context.open && (
          <div {...rest} ref={ref} role={role} id={id}>
            <BaseTooltip size={size}>
              {children}
              <Styled.TooltipArrow
                tipRadius={3}
                height={8}
                context={context}
                ref={arrowRef}
              />
              <Styled.Close aria-label="close" onClick={handleClose}>
                <Icon
                  name="CloseOutline"
                  size="s"
                  color={theme.brand.secondary.lighter}
                />
              </Styled.Close>
            </BaseTooltip>
          </div>
        )}
      </FloatingPortal>
    );
  },
);

export const Toggletip = ToggletipComponent as typeof ToggletipComponent & {
  Header: typeof BaseTooltip.Header;
  Body: typeof BaseTooltip.Body;
};

Toggletip.Header = BaseTooltip.Header;
Toggletip.Body = BaseTooltip.Body;

export default Toggletip;
